<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Lithium_Field_Url')"
        prop="params.url"
        :hint="$t('Integrations_Lithium_Field_Url_Hint')"
      >
        <el-input v-model="model.params.url" placeholder="https://" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_Domain')"
        prop="params.domain"
        :hint="$t('Integrations_Lithium_Field_Domain_Hint')"
      >
        <el-input v-model="model.params.domain" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_EncryptionKey')"
        prop="params.encryption_key"
        :hint="$t('Integrations_Lithium_Field_EncryptionKey')"
      >
        <el-input v-model="model.params.encryption_key" />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'LithiumV2Settings',
  components: {
    FormSection,
    RestFormItem
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          domain: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          encryption_key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/lithiumv2/LithiumV2Settings.vue